import React, { useEffect, useState } from "react";
import { MediaTypes } from "../../../../../../../../_constants/staticData";
import { getS3URL } from "../../../../../../../../_helpers";
import { documentTypeUrl } from "../../../../../../../../_constants/staticData";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import CoursePreview from "../../../../../../../Courses/CoursePreview/CoursePreview";
import ChapterDocument from "../../../../../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";
import axiosInstance from "../../../../../../../../axios";
import { Loading } from "../../../../../../../Other/Loading";
import SCORM from "../../../../../../../../assets/images/SCORM.png";
import ChapterImagePreview from "../../../../../../../Courses/CourseDetails/CourseChapterDetails/chapterImagePreview";
const CourseSectionDocument = ({
  datasource,
  scroms,
  courseImg,
  courseName,
  refreshData,
}) => {
  const [document, setDocument] = useState(false);
  const [show, setShow] = useState(false);
  const [video, setVideo] = useState([]);
  const [image, setImage] = useState([]);
  const [doc, setdocument] = useState([]);
  const [edit, setEdit] = useState(false);
  const [isscrom, setIsscrom] = useState(false);
  const [res, setRes] = useState(null);
  const [imgshow, setImgShow] = useState(false);
  const [imageGetById, setImageGetById] = useState([]);
  const [documentGetById, setDocumentGetById] = useState([]);
  const [videoGetById, setVideoGetById] = useState([]);
  const closeHandler = (id) => {
    setVideoGetById(
      video.filter((item) => {
        return item.id === id;
      })
    );
    setDocument(!document);
  };

  useEffect(() => {
    let videosrc = [];
    let documentsrc = [];
    let imagesrc = [];
    datasource.forEach((element) => {
      if (MediaTypes.videoType.includes(element.fileExt)) {
        videosrc.push({
          name: getS3URL(element.fileName),
          type: element.fileExt,
          originalName: element.originalName,
          courseId: element.courseId,
          id: element.id,
        });
      } else if (MediaTypes.documentTypes.includes(element.fileExt)) {
        documentsrc.push({
          name: getS3URL(element.fileName),
          type: element.fileExt,
          originalName: element.originalName,
          courseId: element.courseId,
          id: element.id,
        });
      } else if (MediaTypes.imageTypes.includes(element.fileExt)) {
        imagesrc.push({
          name: getS3URL(element.fileName),
          type: element.fileExt,
          originalName: element.originalName,
          courseId: element.courseId,
          id: element.id,
        });
      }
    });

    setVideo(videosrc);
    setImage(imagesrc);
    setdocument(documentsrc);
  }, [datasource]);

  const close = (id) => {
    setDocumentGetById(
      doc.filter((item) => {
        return item.id === id;
      })
    );
    setShow(!show);
  };

  const deleteFileService = async (files, courseScrom) => {
    setRes(null);
    const data = {
      courseId: files?.courseId,
      id: files?.id,
      storageType: courseScrom ? "CourseScrom" : "CourseSectionFiles",
    };
    setEdit(true);

    try {
      const response = await axiosInstance.post("delete/file", data);
      setRes(response.data.message);
      refreshData(files.id);
    } catch (error) {
      setRes("Error deleting file.");
      console.error("Delete file error:", error);
    }
  };
  const closeHandlersecond = (values) => {
    setImageGetById(
      image.filter((item) => {
        return item.id === values;
      })
    );
    setImgShow(!imgshow);
  };

  return (
    <>
      <div className="course-sectionmapped">
        {doc.length > 0 && (
          <div className="course-sectionchildMapped">
            {doc.map((element) => (
              <div className="course-superchildMapped">
                <img
                  src={documentTypeUrl.pdf}
                  onClick={() => close(element.id)}
                  alt="document-type"
                />
                <label>{element.originalName}</label>
                <div className="expn-elte-btn">
                  <button
                    className="courseedit-delete"
                    onClick={() => deleteFileService(element, false)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {video.length > 0 && (
          <div>
            <div className="course-sectionchildMapped">
              {video.map((element) => (
                <div className="course-superchildMapped">
                  <img
                    src={documentTypeUrl.videoPlay}
                    onClick={() => closeHandler(element.id)}
                    alt="videoplayIcon"
                  />
                  <label>{element.originalName}</label>
                  <div className="expn-elte-btn">
                    <button
                      className="courseedit-delete"
                      onClick={() => deleteFileService(element, false)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {image.length > 0 && (
          <div className="course-sectionchildMapped">
            {image.map((element) => (
              <div className="course-superchildMapped">
                <img
                  src={element.name}
                  onClick={() => closeHandlersecond(element.id)}
                  alt="icon"
                />
                <label>{element.originalName}</label>
                <div className="expn-elte-btn">
                  <button
                    className="courseedit-delete"
                    onClick={() => deleteFileService(element, false)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {scroms.map((items, index) => (
          <>
            {items?.entryPoint && (
              <div key={`scormFiles${index}`}>
                <img
                  className="scormPreview"
                  src={SCORM}
                  onClick={() => setIsscrom(!isscrom)}
                />
                <label>Scorm File</label>
                <div className="expn-elte-btn">
                  <button
                    className="courseedit-delete"
                    onClick={() => deleteFileService(items, true)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            )}
          </>
        ))}
      </div>

      {isscrom && (
        <>
          {scroms?.map((items) => (
            <div className="view-video">
              <iframe
                height="500px"
                width="100%"
                src={`https://scorm-smiklearn.s3.us-east-2.amazonaws.com/${items.entryPoint}`}
              />
            </div>
          ))}
        </>
      )}

      {show && (
        <>
          {documentGetById.map((element) => (
            <ChapterDocument
              url={element.name}
              type={element.type}
              show={show}
              closeHandler={close}
            />
          ))}
        </>
      )}

      {imgshow && (
        <>
          {imageGetById.map((element) => (
            <ChapterImagePreview
              url={element.name}
              type={element.type}
              show={imgshow}
              closeHandler={closeHandlersecond}
            />
          ))}
        </>
      )}

      {document && (
        <OverlayContainer>
          {videoGetById.map((element) => (
            <CoursePreview
              courseName={courseName}
              courseImg={courseImg}
              courseVid={element.name}
              toogle={setDocument}
            />
          ))}
        </OverlayContainer>
      )}
      {edit && (
        <OverlayContainer>
          <div className="alert-dialog-inner editcourse-popup">
            <div className="close-wrapper" onClick={() => setEdit(false)}>
              <i className="icon check"></i>
            </div>
            <div className="alert-title">
              {res !== undefined ? <h2>{res}</h2> : <Loading />}
            </div>
          </div>
        </OverlayContainer>
      )}
    </>
  );
};
export default CourseSectionDocument;
